// admin/+Page.jsx
import React from "react"
import { usePageContext } from "vike-react/usePageContext"
import AldooRouter from "aldoo-ra/Router"

function Page() {
  const pageContext = usePageContext()
  const urlPathname = pageContext.urlPathname
  const Component = AldooRouter.resolve(urlPathname)
  if (!Component) return <div>404 - Page not found</div>
  return <Component />
}

export default Page
